import { IUtility } from '@interfaces/IUtility';
import { requestService } from '..';

export const createUtilityApi = async (utilityData: Omit<IUtility, '_id'>) => {
	const newUtility: IUtility = await requestService.post(`/projectConfig/utilities`, {
		body: utilityData,
	});
	return newUtility;
};
